const speed_per_chunk__in_secs = 3;
const chunk__in_px = 100;

const ticker = document.querySelector('.subscribe_bar');
if( typeof(ticker) != 'undefined' && ticker != null ) {
  const target = ticker.querySelector('ul');
  let calc = speed_per_chunk__in_secs * ( window.innerWidth / chunk__in_px );
  target.style['animation-duration'] = calc + 's';
}
